import { render, staticRenderFns } from "./InviteRule.vue?vue&type=template&id=023051d3&scoped=true&"
import script from "./InviteRule.vue?vue&type=script&lang=js&"
export * from "./InviteRule.vue?vue&type=script&lang=js&"
import style0 from "./InviteRule.vue?vue&type=style&index=0&id=023051d3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023051d3",
  null
  
)

component.options.__file = "InviteRule.vue"
export default component.exports